import { render, staticRenderFns } from "./PrescribeAll.vue?vue&type=template&id=aa3bf120&scoped=true&"
import script from "./PrescribeAll.vue?vue&type=script&lang=js&"
export * from "./PrescribeAll.vue?vue&type=script&lang=js&"
import style0 from "./PrescribeAll.vue?vue&type=style&index=0&lang=css&"
import style1 from "./PrescribeAll.vue?vue&type=style&index=1&id=aa3bf120&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa3bf120",
  null
  
)

export default component.exports